import { render } from "./UserNotAuthorise.vue?vue&type=template&id=21f8bffc"
import script from "./UserNotAuthorise.vue?vue&type=script&lang=js"
export * from "./UserNotAuthorise.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__